module.exports = __webpack_public_path__ + "img/icon-activity.481f13a2.svg";